import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import styles from './super-user-bar-partner.css'

const SuperUserBarPartner = ({ partnerName }) => (
  <div styleName="super-user-bar-partner">
    You are viewing this partner ({partnerName}) outside of your partner list -
    <a href={'/'} styleName="exit"> Exit</a>
  </div>
)

SuperUserBarPartner.propTypes = {
  partnerName: PropTypes.string,
}

export default CSSModules(SuperUserBarPartner, styles)



/** WEBPACK FOOTER **
 ** ./src/components/super-user-bar/super-user-bar-partner.js
 **/